import styled from '@emotion/styled';

export const SFrame = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  border: black 1px solid;
`;

export const SCopy = styled.div`
  position: absolute;
  top: 50%;
  transform-origin: center;
  transform: translateY(-50%);
  right: 16px;
`;

export const SContainer = styled.div`
  padding-right: 26px;
`;
